// extracted by mini-css-extract-plugin
export default {"main":"styles_main__6GIxY","logo":"styles_logo__W2LN6"};